'use client'
import type { ComponentPropsWithoutRef, ComponentRef, Ref } from 'react'
import * as ProgressPrimitive from '@radix-ui/react-progress'

import cn from '@components/utils/cn'

export type ProgressProps = ComponentPropsWithoutRef<typeof ProgressPrimitive.Root> & {
  progressColor?: string
  size?: 'default' | 'compact'
  ref?: Ref<ComponentRef<typeof ProgressPrimitive.Root>>
}

const Progress = ({ className, value, progressColor, size = 'default', ref, ...props }: ProgressProps) => (
  <ProgressPrimitive.Root
    ref={ref}
    value={value}
    className={cn(
      'tw:relative tw:w-full tw:overflow-hidden tw:rounded-full',
      size === 'compact' ? 'tw:h-1 tw:bg-primary-100' : 'tw:h-2',
      className
    )}
    {...props}
  >
    <ProgressPrimitive.Indicator
      className={cn(
        'tw:h-full tw:w-full tw:flex-1 tw:transition-all',
        progressColor ?? (size === 'compact' && 'tw:bg-primary-500')
      )}
      style={{ transform: `translateX(-${100 - (value ?? 0)}%)` }}
    />
  </ProgressPrimitive.Root>
)

export { Progress }
